import { render } from "./crossTransfer.vue?vue&type=template&id=ce516350&scoped=true"
import script from "./crossTransfer.vue?vue&type=script&lang=js"
export * from "./crossTransfer.vue?vue&type=script&lang=js"

import "./crossTransfer.vue?vue&type=style&index=0&id=ce516350&lang=less&scoped=true"

import exportComponent from "D:\\AICodeSpace\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce516350"]])

export default __exports__